<div class="modal-header">
  <h4 class="modal-title"> {{'settingsTabNavigator.label.wire_bridge_settings' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-6 col-form-label text-end font-weight-bold" for="crossSection">
          {{'rightPanel.dataGrid.cross_section' | translate}}:
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <input class="form-control" type="text" id="crossSection" formControlName="crossSection">
            <div class="input-group-append">
              <span class="input-group-text">{{'global.unit.label.mmPow2' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-6 col-form-label text-end font-weight-bold" for="cableLength">
          {{'rightPanel.dataGrid.cable_length' | translate}}:
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <input class="form-control" type="text"
              id="cableLength"
              (inputEvent)="form.controls.cableLength.setValue($event)"
              inputRestricter="^[0-9]*$"
              formControlName="cableLength">
            <div class="input-group-append">
              <span class="input-group-text">{{'global.unit.label.mm' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-6 col-form-label text-end font-weight-bold" for="color">
          {{'rightPanel.dataGrid.color' | translate}}:
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <input class="form-control" type="text" id="color" formControlName="color">
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" *ngIf="hasEditPermission" (click)="save()">{{'global.label.save' | translate}}</button>
</div>
